import Swiper from '../autoload/_swiper';

class GalleryFSCarousel {

    doAThing() {
        console.log('animations Do a thing')

    }

    constructor(){

      console.log('GalleryCarousel')

        var swiperClass = '.gallery-fs-swiper';

        $(swiperClass).each(function ( index ) {

          console.log('GalleryFSCarousel')

            var swiperID = 'gallery-fs-' + index;
            var swiperIDHash = '#gallery-fs-' + index;

            $(this).attr('id', swiperID);

            var homeSwiper = new Swiper(swiperIDHash, {

                centeredSlides: true,
                speed: 500,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },

                pagination: {
                    el: '.swiper-fs-pagination',
                    clickable: true,
                },
                on: {
                    init() {
                        setTimeout(() => {
                            window.dispatchEvent(new Event('resize'))
                        }, 200)
                    },
                },

            });

            homeSwiper.on('transitionStart', function () {

                //console.log('transitionStart');

            });

        });

    }
}

export default GalleryFSCarousel



// WEBPACK FOOTER //
// ./scripts/util/galleryFSCarousel.js